(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_a5a8604"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pf-color-toggle')){
 class PfColorToggle extends HTMLElement {
  connectedCallback(){
   this.button=this.querySelector('button');
   let dark=document.documentElement.dataset.pfMode==='dark';
   try{dark=localStorage.getItem('pokeglyph-color-mode')==='dark';}catch(error){}
   this.apply(dark);
   this.clickHandler=()=>{const next=document.documentElement.dataset.pfMode!=='dark';this.apply(next);try{localStorage.setItem('pokeglyph-color-mode',next?'dark':'light');}catch(error){}};
   this.storageHandler=event=>{if(event.key==='pokeglyph-color-mode')this.apply(event.newValue==='dark');};
   this.button.addEventListener('click',this.clickHandler);
   window.addEventListener('storage',this.storageHandler);
  }
  apply(dark){document.documentElement.dataset.pfMode=dark?'dark':'light';document.querySelectorAll('pf-color-toggle button').forEach(button=>button.setAttribute('aria-pressed',String(dark)));}
  disconnectedCallback(){this.button?.removeEventListener('click',this.clickHandler);window.removeEventListener('storage',this.storageHandler);queueMicrotask(()=>{if(!document.querySelector('pf-color-toggle'))document.documentElement.dataset.pfMode='light';});}
 }
 customElements.define('pf-color-toggle',PfColorToggle);
}
  } catch(e) { console.error(e); }
})();

})();
